import React, {useEffect, useState} from 'react';
import {Button, Drawer, Tooltip} from "antd";
import closeBtn from "../../../images/close-btn.png";
import rightArrow from "../../../images/arrow-right.png";
import {booleanPipe, numberPipe, percentPipe} from "../../Installations/pipeFormaters";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {fetchLocationTableData, setLocation} from "../../../redux-store/map";
import AppLoader from "../../ApplicationComponent/Loader";
import {
    getActiveAlarms,
    getActiveAlarmsPagination,
    getLocationLoader,
    getLocationTableData,
    getUserInfo
} from "../../../redux-store/selectors";
import {
    clearActiveAlarms,
    fetchActiveAlarmsByLocationId,
    fetchNonReportableActiveAlarmsByLocationId
} from "../../../redux-store/alarms";
import {getLocationParametersView, timeStampToTimeString} from "../../../constants/FunctionJS";
import {BsFillArrowDownCircleFill} from "react-icons/bs";
import {mapLevelToImage} from "../Alarms/AlarmsTable";
import {checkUserViewer} from "../../authHelpers";
import {sendCommand} from "../../Installations/commands";

export const getNumberField = ({title, value, pipeArg, description}) => {
    return <div className={"drawer-item-container"}>
        <div className={"drawer-item-label"}><Tooltip title={description}>{title}</Tooltip></div>
        <div className={"drawer-item-value"}
             style={{width: "80px"}}>{value !== null ? numberPipe(value, pipeArg) : "0"}</div>
    </div>
}

export const getTextField = (item) => {
    const {title, description} = item
    return <div className={"drawer-item-container"}>
        <div className={"drawer-item-label"}><Tooltip title={description}>{title}</Tooltip></div>
        <div className={"drawer-item-value"} style={{width: "80px"}}>
            <Button className={"trigger-button-on-off"} disabled={true}>{title}</Button>
        </div>
    </div>
}

export const getTextFieldWithCommand = (item) => {
    const {title, description} = item
    return <div className={"drawer-item-container"}>
        <div className={"drawer-item-label"}><Tooltip title={description}>{title}</Tooltip></div>
        <div className={"drawer-item-value"} style={{width: "80px"}}>
            <Button className={"trigger-button-on-off"} onClick={() => {
                sendCommand(item.commandArgs.deviceId, {
                    methodName: item.commandArgs.methodName,
                    arguments: item.commandArgs.arguments
                }, true)
            }}>{title}</Button>
        </div>
    </div>
}
export const getBooleanField = ({title, value, pipeArg, description}) => {
    const spanValue = value ? "on" : "off";
    return <div className={"drawer-item-container"}>
        <div className={"drawer-item-label"}><Tooltip title={description}>{title}</Tooltip></div>
        {value !== null &&
            <div><span
                className={`drawer-item-boolean-${spanValue}`}>{booleanPipe(value, pipeArg)}</span>
            </div>}
    </div>
}
export const getPercentageField = ({title, value, pipeArg, description}) => {
    return <div className={"drawer-item-container"}>
        <div className={"drawer-item-label"}><Tooltip title={description}>{title}</Tooltip></div>
        <div className={"drawer-item-value"}
             style={{width: "80px"}}>{value !== null ? percentPipe(value, pipeArg) : "0"}</div>
    </div>
}
export const getAlarmContainer = alarm => {
    const datetimeString = timeStampToTimeString(alarm.triggeredAt);
    return (
        <div className={"map-drawer-alarms-details"}>
            <div className={"d-flex justify-content-start"}>
                <img src={mapLevelToImage[alarm.level]} width={20} height={20} className={"me-2"}/>
                <div className={"map-drawer-alarm-text"}>{alarm.alarmText}</div>
            </div>
            <div>
                {datetimeString}
            </div>
        </div>
    )
};

const MapSideDrawer = ({location = null, installationId = null, show, onClose}) => {
    const dispatch = useDispatch();
    const navigation = useNavigate();

    const [online, setOnline] = useState(false);

    const [parametersLIst, setParametersList] = useState([]);

    const userInfo = useSelector(getUserInfo)
    const locationTableData = useSelector(getLocationTableData);
    const alarms = useSelector(getActiveAlarms);
    const loading = useSelector(getLocationLoader);
    const {currentPage, total, pageSize} = useSelector(getActiveAlarmsPagination);


    const addData = (cell, item) => {
        if (item.parameterName === "online") {
            setOnline(cell.value);
        }
        return {
            commandArgs: {
                methodName: item?.methodName,
                arguments: item?.arguments,
                deviceId: cell?.deviceId,
            },
            type: item.type,
            name: item.parameterName,
            value: cell.value,
            title: item.title,
            pipe: item.pipe,
            pipeArg: item.pipeArg,
            alignment: item.alignment,
            description: item.description,
        }
    }

    useEffect(() => {
        if (locationTableData.length === 0) return;
        const tableData = locationTableData[0];
        const hasData = tableData.columns.length > 0 && tableData.rows[0]?.cells.length > 0;
        const pomData = [];
        if (hasData) {
            const columns = tableData.columns;
            const cells = tableData.rows[0]?.cells;
            columns.forEach((item, counter) => {
                if (checkUserViewer(userInfo)) {
                    if (item.type === "DATA") {
                        pomData.push(addData(cells[counter], item))
                    }
                } else {
                    pomData.push(addData(cells[counter], item))
                }
            })
        }
        setParametersList(pomData)

    }, [locationTableData]);

    useEffect(() => {
        if (location === null || installationId === null)
            return;
        dispatch(fetchLocationTableData({installationId: installationId, locationId: location.id}));
        dispatch(fetchActiveAlarmsByLocationId({installationId: installationId, locationId: location.id}));
    }, [location]);

    const bodyData = getLocationParametersView(parametersLIst);

    const handleLocationDetails = () => {
        dispatch(setLocation(location));
        navigation(`/location-devices`);
    }

    const handleShowMore = () => {
        dispatch(fetchActiveAlarmsByLocationId({
            installationId: installationId,
            locationId: location.id,
            page: currentPage + 1
        }));
    }
    const showMoreButton = ((currentPage + 1) * pageSize) < total;

    const handleDrawerClose = () => {
        dispatch(clearActiveAlarms());
        onClose();
    }
    return (
        <Drawer
            placement="right"
            closable={false}
            onClose={handleDrawerClose}
            visible={show}
            getContainer={false}
            style={{position: 'absolute'}}

        >
            {loading ? <AppLoader/> : <>
                <div className={"map-drawer-header"}>
                    <div className={"map-drawer-header-box"}>
                        <div className={"map-drawer-title-container"}><span
                            className={"map-drawer-title"}>{location?.name}</span></div>
                        <div><span
                            className={`${online ? "map-drawer-status-on" : "map-drawer-status-off"}`}>{online ? "ONLINE" : "OFFLINE"}</span>
                        </div>
                    </div>
                    <div className={"map-drawer-close-btn-container"}>
                        <img src={closeBtn} width={20} height={20} onClick={handleDrawerClose}/>
                    </div>
                </div>
                <div className={"map-drawer-body"}>
                    <div className={"map-drawer-body-items-container"}>
                        {bodyData}
                    </div>
                    <div className={"map-drawer-alarms"}>
                        {alarms.map(item => getAlarmContainer(item))}
                        {showMoreButton && <div className={"show-more-button"}>
                            <div className={"text-center mt-2"}>
                                <button onClick={handleShowMore} className={"btn-show-more-scroll"}>Prikaži
                                    više <BsFillArrowDownCircleFill/></button>
                            </div>
                        </div>}
                    </div>
                    <div>
                        <span className={"map-drawer-device-link"} onClick={handleLocationDetails}>
                            Više detalja o lokaciji<img src={rightArrow} width={20} height={20}/>
                        </span>
                    </div>
                </div>
            </>}
        </Drawer>
    );
};

export default MapSideDrawer;
